var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 -4.37112e-08C8.55228 -1.95702e-08 9 0.421379 9 0.941176L9 15.0588C9 15.5786 8.55228 16 8 16C7.44771 16 7 15.5786 7 15.0588L7 0.941176C7 0.421379 7.44772 -6.78523e-08 8 -4.37112e-08Z",
    fill: "#FF7C02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 7.44772 0.421379 7 0.941176 7H15.0588C15.5786 7 16 7.44772 16 8C16 8.55228 15.5786 9 15.0588 9H0.941176C0.421379 9 0 8.55228 0 8Z",
    fill: "#FF7C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPrimary);
export default __webpack_public_path__ + "static/media/plus-primary.01feb4d55efea5fc28bcd158cead9d89.svg";
export { ForwardRef as ReactComponent };